// extracted by mini-css-extract-plugin
module.exports =  {"container":"aCyESxBeo3R5i6xj33y6","row":"gu9hOw1OKtohAA0v5o_6","heading":"Uq_Altk90d6QJQq5cAFq"};